import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const ProductCard = ({ product }) => {
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star
          key={i}
          className={`w-3 h-3 ${
            i < fullStars
              ? 'fill-yellow-400 text-yellow-400'
              : i === fullStars && hasHalf
              ? 'fill-yellow-400/50 text-yellow-400'
              : 'text-neutral-300'
          }`}
        />
      );
    }
    return stars;
  };

  const formatReviews = (count) => {
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}k`;
    }
    return count;
  };

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="product-image-wrapper relative aspect-square bg-secondary mb-4 overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        
        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {product.is_bestseller && (
            <span className="badge-bestseller px-3 py-1 text-[10px] uppercase tracking-widest font-bold">
              Bestseller
            </span>
          )}
          {product.is_new && (
            <span className="badge-new px-3 py-1 text-[10px] uppercase tracking-widest font-bold">
              New
            </span>
          )}
          {product.original_price && product.original_price > product.price && (
            <span className="badge-sale px-3 py-1 text-[10px] uppercase tracking-widest font-bold">
              Sale
            </span>
          )}
        </div>
      </div>

      {/* Details */}
      <div className="space-y-2">
        {/* Brand */}
        <p className="text-xs uppercase tracking-[0.15em] text-neutral-500">
          {product.brand}
        </p>

        {/* Name */}
        <h3 className="font-body text-sm font-medium line-clamp-2 group-hover:text-neutral-600 transition-colors">
          {product.name}
        </h3>

        {/* Rating */}
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-0.5">
            {renderStars(product.rating)}
          </div>
          <span className="text-xs text-neutral-500">
            ({formatReviews(product.review_count)})
          </span>
        </div>

        {/* Price */}
        <div className="flex items-center gap-2">
          <span className="font-semibold">${product.price.toFixed(2)}</span>
          {product.original_price && product.original_price > product.price && (
            <span className="text-sm text-neutral-400 line-through">
              ${product.original_price.toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
